import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Check } from "lucide-react";
import { CheckoutButton } from "./CheckoutButton";
import { useSite, useImages } from "@/context/SiteContent";

export const StickyBuyBar = () => {
  const { price, bookingCta, offer } = useSite();
  const images = useImages();
  const [show, setShow] = useState(false);
  useEffect(() => {
    const f = () => {
      const booking = document.getElementById("booking");
      const bookingTop = booking ? booking.getBoundingClientRect().top + window.scrollY : Infinity;
      const y = window.scrollY;
      setShow(y > 900 && y + window.innerHeight < bookingTop + 120);
    };
    f();
    window.addEventListener("scroll", f, { passive: true });
    return () => window.removeEventListener("scroll", f);
  }, []);
  return (
    <AnimatePresence>
      {show && (
        <motion.div className="buybar" initial={{ opacity: 0, y: 26, x: "-50%" }} animate={{ opacity: 1, y: 0, x: "-50%" }} exit={{ opacity: 0, y: 26, x: "-50%" }} transition={{ duration: 0.35, ease: [0.2, 0.7, 0.2, 1] }} data-testid="sticky-buy-bar">
          <img src={images.cover} alt="" />
          <div className="buybar-copy">
            <strong>From Campus to Corporate</strong>
            <span>52 lessons · 5Ps · One-time {price}</span>
            {offer.includeBadge && (
              <span className="buybar-badge" data-testid="buybar-include-badge"><Check size={12} strokeWidth={3} /> {offer.includeBadge}</span>
            )}
          </div>
          <a className="buybar-book" href="#booking" data-testid="sticky-bar-booking">{bookingCta}</a>
          <CheckoutButton testId="sticky-bar-checkout" style={{ minHeight: 44, padding: "0 18px" }}>Get the eBook</CheckoutButton>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
